import request from '@/utils/request.js'
import API_URL from '@/utils/sourceApiUrl'

const state = {
	configs: null
}

const mutations = {
	setConfigs(state, configs) {
		state.configs = {
			...(state.configs || {}),
			...configs
		}
	},
}

const actions = {
	async fetchConfigs({ state, rootState, commit }) {
		const platform = rootState.platform
		const { configs } = await request.get(`${API_URL[platform]}/admin/configs`)
		commit('setConfigs', configs)
		return configs
	},
	async setConfigs({ state, rootState, commit }, configs) {
		const platform = rootState.platform
		await request.put(`${API_URL[platform]}/admin/configs`, { configs })
		commit('setConfigs', configs)
		return {
			...(state.configs || {}),
			...configs
		}
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
